const productData = {
  "normal-vermicompost": {
    title: "Vermicompost",
    image: "/img/normal-vermicompost.jpg",
    images: [
      "/img/normal-vermicompost.jpg",
      "/img/vermicompost-2.jpg",
      "/img/vermicompost-3.jpg",
      "/img/normal-vermicompost.jpg",
    ],
    shortDescription:
      "Natural compost made using earthworms to improve soil structure and support steady plant growth. Ideal for regular soil conditioning.",
    description:
      "Our vermicompost is naturally prepared using cow dung and earthworms through a slow, biological decomposition process. It helps improve soil structure, increases moisture retention, and supports steady, balanced plant growth. Ideal for regular soil conditioning, it restores soil health over time without the use of chemicals. This vermicompost is best suited for routine nutrient support in home gardens, pots, and farming fields.",
    benefits: [
      "Improves soil structure and long-term fertility",
      "Helps soil retain moisture and reduces dryness",
      "Supports healthy root development",
      "Encourages steady and natural plant growth",
      "Safe for vegetables, fruits, flowers, and indoor plants",
      "Eco-friendly and suitable for regular use",
    ],
    bestFor: [
      "Kitchen gardens and home gardens",
      "Potted plants and grow bags",
      "Farming fields and open soil",
      "Regular soil conditioning and maintenance",
    ],
    usage: [
      "Mix 20–30% vermicompost with soil for general use",
      "For pots, mix 1 part vermicompost with 3–4 parts soil",
      "Can be mixed directly into soil or used along with a potting mixture",
      "For best results, use with our potting mixture",
    ],
    whyUse:
      "Prepared patiently using natural processes, this vermicompost improves soil health gradually and safely, making it ideal for everyday use across all types of plants and growing conditions.",
    whatsappMessage:
      "Hi! I'm interested in buying Vermicompost. Can you provide more details about pricing and availability?",
  },

  "trichoderma-vermicompost": {
    title: "Trichoderma-Based Vermicompost",
    image: "/img/trichoderma-vermicompost.jpg",
    images: [
      "/img/trichoderma-vermicompost.jpg",
      "/img/vermicompost-2.jpg",
      "/img/vermicompost-3.jpg",
      "/img/trichoderma-vermicompost.jpg",
    ],
    shortDescription:
      "Vermicompost enriched with beneficial fungi to support root health and reduce soil-borne problems naturally.",
    description:
      "Our Trichoderma-based vermicompost is prepared by enriching natural vermicompost with beneficial Trichoderma fungi. This combination supports soil health while helping protect plant roots from common soil-borne problems. It strengthens root systems, improves soil balance, and supports healthier plant growth over time. This compost is especially useful in disease-prone soils and for crops that require extra root protection, without relying on chemical fungicides.",
    benefits: [
      "Helps protect roots from common soil-borne diseases",
      "Enriched with beneficial Trichoderma fungi",
      "Supports stronger and healthier root development",
      "Improves plant resistance and overall resilience",
      "Maintains a balanced and living soil ecosystem",
      "Helps reduce dependence on chemical fungicides",
    ],
    bestFor: [
      "Disease-prone or repeatedly used soils",
      "Sensitive crops and young plants",
      "Farming fields where chemical fungicide use is to be reduced",
      "Long-term soil health and root protection",
    ],
    usage: [
      "Mix 20–25% with soil in affected areas",
      "Apply near the root zone for better effectiveness",
      "Can be mixed directly into soil or used along with a potting mixture",
      "Avoid mixing with chemical fungicides immediately after application",
      "For best results, use with our potting mixture",
    ],
    whyUse:
      "This compost combines natural nutrition with biological soil protection, making it a practical solution for farmers and growers who want healthier roots and stronger plants without chemical dependency.",
    whatsappMessage:
      "Hi! I'm interested in buying Trichoderma-Based Vermicompost. Can you provide more details about pricing and availability?",
  },

  "premium-vermicompost": {
    title: "Premium Vermicompost",
    image: "/img/premium-vermicompost.jpg",
    images: [
      "/img/premium-vermicompost.jpg",
      "/img/vermicompost-3.jpg",
      "/img/vermicompost-2.jpg",
      "/img/premium-vermicompost.jpg",
    ],
    shortDescription:
      "Carefully cured vermicompost with finer texture and higher biological activity. Designed for deeper, long-term soil improvement.",
    description:
      "Our Premium Vermicompost is carefully prepared using well-decomposed organic matter and given extended curing time. This slow process results in a finer texture, richer organic content, and higher biological activity. It works deeper into the soil, improving fertility and structure over time rather than providing quick, short-term results. This product is designed for growers who focus on long-term soil health and stronger plant development.",
    benefits: [
      "Rich in stable organic matter",
      "Higher microbial activity for living soil",
      "Ultra-fine texture for easy mixing and absorption",
      "Carefully processed and well-cured",
      "Supports stronger root and plant development",
      "Improves soil health over the long term",
    ],
    bestFor: [
      "Fruit and vegetable crops",
      "Flowering plants and ornamentals",
      "Nurseries and plant propagation",
      "Growers seeking deeper soil improvement",
    ],
    usage: [
      "Mix 10–15% with soil for beds and fields",
      "For pots, mix 1 part premium vermicompost with 5 parts soil",
      "Can be mixed directly into soil or used along with a potting mixture",
      "Suitable for pre-plant soil preparation and ongoing soil improvement",
      "For best results, use with our potting mixture",
    ],
    whyUse:
      "Prepared with patience and care, this vermicompost improves soil from within, making it ideal for growers who value soil health, consistency, and sustainable plant growth.",
    whatsappMessage:
      "Hi! I'm interested in buying Premium Vermicompost. Can you provide more details about pricing and availability?",
  },

  "coco-peat": {
    title: "Coco Peat",
    image: "/img/coco-peat.jpg",
    images: [
      "/img/coco-peat.jpg",
      "/img/coco-peat.jpg",
      "/img/vermicompost-3.jpg",
      "/img/coco-peat.jpg",
    ],
    shortDescription:
      "A natural growing medium that improves moisture retention and aeration. Best used as a base for seed starting and containers.",
    description:
      "Our coco peat is a natural growing medium made from processed coconut husk. It helps soil hold moisture while keeping it light and airy, allowing roots to grow freely. Coco peat supports healthy root development and is commonly used for seed starting, container gardening, and improving soil moisture balance. It is best used by mixing with compost or soil, as coco peat itself does not provide nutrients.",
    benefits: [
      "Holds moisture efficiently and reduces frequent watering",
      "Improves soil aeration and root breathing",
      "Supports healthy and strong root growth",
      "Lightweight and easy to handle",
      "Eco-friendly and biodegradable",
      "Can be reused after proper cleaning",
    ],
    bestFor: [
      "Seed germination and nursery trays",
      "Pots, grow bags, and container gardening",
      "Improving soil moisture retention",
      "Mixing with compost and soil",
    ],
    usage: [
      "Soak and loosen coco peat before use",
      "Mix with compost or soil for balanced growth",
      "Avoid using alone for long-term plant growth",
      "For best results, use with our vermicompost or potting mixture",
    ],
    whyUse:
      "A sustainable and eco-friendly growing medium that works excellently when combined with our vermicompost, providing the perfect balance of moisture retention and aeration for healthy plant growth.",
    whatsappMessage:
      "Hi! I'm interested in buying Coco Peat. Can you provide more details about pricing and availability?",
  },

  "vermiwash": {
    title: "Vermiwash",
    image: "/img/vermiwash-main.png",
    images: [
      "/img/vermiwash-main.png",
      "/img/vermiwash-use.png",
      "/img/vermiwash-texture.png",
      "/img/vermiwash-main.png",
    ],
    shortDescription:
      "A natural liquid extract from the vermicomposting process, rich in beneficial microorganisms and nutrients that support healthy plant development.",
    description:
      "Our vermiwash is a natural liquid extract collected during the vermicomposting process. It contains beneficial microorganisms, plant growth–promoting substances, and essential nutrients that support healthy plant development. This liquid organic formulation helps improve nutrient absorption, strengthens root systems, and supports overall plant vitality. Suitable for farms, nurseries, terrace gardens, and home plants, it offers a convenient way to provide additional nourishment without chemical inputs. Designed for regular use, it works as a gentle yet effective supplement for sustainable plant care.",
    benefits: [
      "Enhances overall plant growth",
      "Supports strong root development",
      "Improves nutrient uptake efficiency",
      "Promotes better leaf and stem health",
      "Encourages flowering and fruiting",
      "100% organic and chemical-free",
    ],
    bestFor: [
      "Vegetables and fruits",
      "Flowering plants",
      "Indoor and outdoor plants",
      "Field crops and nursery plants",
    ],
    usage: [
      "Dilute with water before application (recommended 1:10 ratio)",
      "Apply as foliar spray or soil drenching",
      "Use every 10–15 days for best results",
      "Shake well before use",
    ],
    whyUse:
      "This vermiwash provides a natural and easy-to-apply liquid nutrient solution, making it suitable for growers who want consistent plant support while maintaining organic and sustainable practices.",
    whatsappMessage:
      "Hi! I'm interested in buying Vermiwash. Can you provide more details about pricing and availability?",
  },

  "potting-mixture": {
    title: "Potting Mixture",
    image: "/img/potting-mixture.jpg",
    images: [
      "/img/potting-mixture.jpg",
      "/img/vermicompost-2.jpg",
      "/img/vermicompost-3.jpg",
      "/img/potting-mixture.jpg",
    ],
    shortDescription:
      "A ready-to-use soil blend designed for healthy root growth in pots and containers. Suitable for indoor and home gardens.",
    description:
      "Our potting mixture is a balanced, ready-to-use blend made for potted plants and home gardens. It provides proper drainage, good air flow, and steady nutrition to support healthy root growth and consistent plant development. This mix is suitable for both indoor and outdoor containers and helps plants establish easily without extra preparation. Designed for convenience and reliable results, it is ideal for everyday gardening needs.",
    benefits: [
      "Ready to use, no additional mixing required",
      "Balanced nutrients for steady plant growth",
      "Good drainage to prevent waterlogging",
      "Maintains moisture without making soil heavy",
      "Supports healthy root development",
      "Suitable for indoor and outdoor plants",
    ],
    bestFor: [
      "Indoor plants",
      "Home gardens and terrace gardens",
      "Pots, planters, and grow bags",
      "Nursery and container planting",
    ],
    usage: [
      "Can be used directly for planting or repotting",
      "Fill pots or planters directly with the potting mixture",
      "Water lightly after planting",
      "Suitable for regular repotting and seasonal planting",
      "For added organic support, it can be used along with our vermicompost",
    ],
    whyUse:
      "This potting mixture offers a simple and dependable solution for healthy plant growth, making it ideal for gardeners who want ease of use along with balanced soil support.",
    whatsappMessage:
      "Hi! I'm interested in buying Potting Mixture. Can you provide more details about pricing and availability?",
  },
};

export default productData;
